import { z } from "zod";

/**
 * Pipedream action component — stored in AgentExternalTool.actions
 * when type = PIPEDREAM. Shape is the Pipedream SDK's V1Component.
 *
 * Written by pipedream-app-fetch.service.ts as GetComponentsResponse.data directly.
 * At runtime, PluginNode.ts passes node.data.selectedAction (the component key)
 * to pd.runAction() — the stored actions array is the component catalog.
 *
 * ⚠️ KNOWN BUG: tools-marketplace.service.ts casts Pipedream actions as ActionType[]
 * (Nexus's own action format) which has a completely different shape. Fields like
 * path, method, operationId, parametersFields, bodyFields do not exist on V1Component.
 * The marketplace service accesses disabled/parametersFields/bodyFields — all undefined
 * for Pipedream components. This is a pre-existing mismatch, tracked separately.
 *
 * configurable_props uses z.array(z.unknown()) — each prop is one of 15+ Pipedream
 * prop types (string, boolean, app, object, http, sql, etc.) defined in @pipedream/sdk.
 * They are fully opaque to Nexus.
 */
export const PipedreamActionSchema = z
  .object({
    name: z.string(),
    key: z.string(),
    version: z.string(),
    description: z.string().optional(),
    component_type: z.string().optional(),
    stash: z.enum(["optional", "required"]).optional(),
    configurable_props: z.array(z.unknown())
  })
  .passthrough();

export type PipedreamAction = z.infer<typeof PipedreamActionSchema>;
